// extracted by mini-css-extract-plugin
export default {"buyerArea":"CreateOrderDialog_buyerArea__XeALB"};